import React, { useState, useEffect } from "react";
import { Phone, MapPin, Star, ChevronDown } from "lucide-react";
import { CONTACT, BANNERS } from "../mock";
import { Button } from "../components/ui/button";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Hero = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(
      () => setActive((a) => (a + 1) % BANNERS.length),
      5000
    );
    return () => clearInterval(t);
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-[92vh] flex items-center pt-24 pb-16 overflow-hidden"
    >
      {/* Rotating banner images */}
      <div className="absolute inset-0">
        {BANNERS.map((b, i) => (
          <img
            key={i}
            src={b.image}
            alt={b.alt}
            className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000 ${
              i === active ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
        {/* Overlay: stronger on left for text, keeps images visible on right/bottom */}
        <div className="absolute inset-0 bg-gradient-to-r from-orange-950/92 via-orange-950/70 to-orange-900/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-orange-950/70 via-transparent to-transparent md:from-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl text-white animate-fadeUp">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur px-4 py-1.5 text-xs sm:text-sm mb-6 border border-white/20">
            <Star className="h-4 w-4 text-amber-300 fill-amber-300" />
            Trusted for 10+ Years • 1000+ Happy Pilgrims
          </div>

          <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl leading-tight mb-5">
            Hyderabad to{" "}
            <span className="text-amber-300">Srisailam</span> Cab Tour Packages
          </h1>

          <p className="text-base sm:text-lg text-orange-50/90 mb-8 max-w-xl">
            Embark on a divine journey to the sacred Mallikarjuna Jyothirlinga.
            Comfortable cabs, experienced drivers and all-inclusive packages for a
            memorable pilgrimage.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a href={`tel:+91${CONTACT.primary}`}>
              <Button
                size="lg"
                className="w-full sm:w-auto bg-amber-400 hover:bg-amber-300 text-orange-950 font-semibold rounded-full gap-2 shadow-xl text-base px-8"
              >
                <Phone className="h-5 w-5" /> Book Now: {CONTACT.primary}
              </Button>
            </a>
            <Button
              size="lg"
              variant="outline"
              onClick={() => scrollTo("packages")}
              className="w-full sm:w-auto bg-transparent border-white/60 text-white hover:bg-white/10 hover:text-white rounded-full text-base px-8"
            >
              View Packages
            </Button>
          </div>

          <div className="flex items-start gap-2 mt-8 text-sm text-orange-50/80">
            <MapPin className="h-4 w-4 text-amber-300 mt-0.5 shrink-0" />
            {CONTACT.address}
          </div>
        </div>
      </div>

      {/* Carousel dots */}
      <div className="absolute bottom-8 right-6 sm:right-10 flex gap-2 z-10">
        {BANNERS.map((_, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            aria-label={`Show banner ${i + 1}`}
            className={`h-2.5 rounded-full transition-all duration-300 ${
              i === active ? "w-8 bg-amber-400" : "w-2.5 bg-white/50"
            }`}
          />
        ))}
      </div>

      <button
        onClick={() => scrollTo("packages")}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/80 animate-floatY"
        aria-label="Scroll down"
      >
        <ChevronDown className="h-8 w-8" />
      </button>
    </section>
  );
};

export default Hero;
